import React from 'react';
import { randomId } from '@/utils/random';
import { RequestUploadUrlType } from '../graphql/generatedTypes';
import uploadToS3 from '@/utils/imageUpload';
import { useRequestUploadUrlMutation } from '../graphql/mutations/requestUploadUrl.generated';

export function useOnUploadFileHook(uploadType: RequestUploadUrlType) {
  const [requestUploadUrl] = useRequestUploadUrlMutation();
  const [loading, setLoading] = React.useState(false);
  return {
    loading,
    getUrlForS3FileUploadOnFileInputChangeEvent: async (
      e: React.ChangeEvent<HTMLInputElement>,
    ) => {
      const { files } = e.target;
      const file = (files || [])[0];
      if (file) {
        setLoading(true);
        const { name: filename, type: filetype } = file;
        let uniqueFilename = randomId(6) + '_' + filename;
        const { data } = await requestUploadUrl({
          variables: {
            filename: uniqueFilename,
            filetype,
            type: uploadType,
          },
        });
        if (data?.requestUploadUrl) {
          const url = await uploadToS3(file, data.requestUploadUrl);
          setLoading(false);
          return url;
        } else {
          alert('error uploading file');
        }
      }
      setLoading(false);
      return null;
    },
  };
}
